module.exports = __webpack_public_path__ + "static/media/area-do-proprietario.e4e0632a.webp";